import { render } from "./Erro.vue?vue&type=template&id=061e9350"
import script from "./Erro.vue?vue&type=script&lang=js"
export * from "./Erro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__